import "../styles/Parts&Engines.css";
import { Typography, Button, AppBar, Toolbar, Grid2} from "@mui/material";
import logo from "../assets/LOGO.jpg";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Link } from "react-router-dom";
import { GoogleMap, LoadScript, Marker } from "@react-google-maps/api";
import { useEffect, useRef, useState } from "react";
import emailjs from '@emailjs/browser';

const PartsEngineSales = () => {
  const [showPhoneModal, setShowPhoneModal] = useState(false);
  const form = useRef();
  const [showTooltip, setShowTooltip] = useState(false);
  const sendEmail = (e) => {
    e.preventDefault();

    const formData = {
      user_name: form.current.user_name.value,
      phone: form.current.phone.value,
      alternate_phone: form.current.alternate_phone.value,
      email: form.current.email.value,
      engine_serial_number: form.current.engine_serial_number.value,
      part_names: form.current.part_names.value,
      part_numbers: form.current.part_numbers.value,
      comments: form.current.comments.value,
    };

    emailjs.send('service_riat5gd', 'template_l5evviz', formData, 'YKIZWeVRe6T9FLWqO')
      .then((result) => {
        console.log(result.text);
        alert('Mensaje enviado exitosamente!');
        form.current.reset(); // Limpiar el formulario después de enviar el correo exitosamente
      }, (error) => {
        console.error('Error al enviar el mensaje:', error);
        alert(`Hubo un error al enviar el mensaje: ${error.text}`);
      });
  };
  useEffect(() => {
    const hash = window.location.hash;
    if (hash === '#form-section') {
      const element = document.getElementById('form-section');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }
    if (hash === '#fotos-partes') {
      const element = document.getElementById('fotos-partes');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }
    
  }, []); 
  const mapContainerStyle = {
    width: "100%",
    height: "100%",
  };

  const center = {
    lat: 26.07687,
    lng: -80.21041,
  };
  const handleScroll = () => {
    document.getElementById('form-section').scrollIntoView({ behavior: 'smooth', block: 'center' });
  };
    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        fade: true,
        nextArrow: null,
        prevArrow: null,
      };
    return (
      <div className="parts-engine-sales">
        <div className="header-parts">
          <AppBar color="white">
            <Toolbar>
              <Grid2 container alignItems="center" className="header-Grid2-parts">
                <Grid2 item>
                    <img className="logo" src={logo} alt="logo"/>
                </Grid2>
                <Grid2 item>
                <Link to='/'><Button color="inherit" >Home</Button></Link>
                </Grid2>
                <Grid2 item>
                <Link to='#'><Button color="inherit" >Parts & Engine Sales</Button></Link>
                </Grid2>
                <Grid2 item>
                <Link to='/Service'><Button color="inherit" > Service</Button></Link>
                </Grid2>
                <Grid2 item>
                <Link to='/OtherBrands'><Button color="inherit" >Other Brands</Button></Link>
                </Grid2>
                <Grid2 item>
                <Link to='/AboutUs'><Button color="inherit" > About Us</Button></Link>
                </Grid2>
                <Grid2 item xs />
                <Grid2 item>
                  <a href="mailto:fitoto9349@nalwan.com"><Button className="contact-button" >Contact Us</Button></a>
              </Grid2>
              </Grid2>
            </Toolbar>
          </AppBar>
        </div>
        <div className="body">
        <Slider {...settings}>
        <div className="slider" id="fotos-partes">
              <img src={require("../assets/_W3A6974.jpg")} alt="Expert Dieselt" />
            </div>
            <div>
              <img src={require("../assets/_W3A6966.jpg")} alt="Expert Diesel" />
            </div>
            <div>
              <img src={require("../assets/_W3A6990.jpg")} alt="Expert Diesel" />
            </div>
            <div>
              <img src={require("../assets/_W3A6971.jpg")} alt="Expert Diesel" />
            </div>
            <div>
              <img src={require("../assets/IMG-20241226-WA0002.jpg")} alt="Expert Diesel" />
            </div>
            <div>
              <img src={require("../assets/IMG-20241226-WA0005.jpg")} alt="Expert Diesel" />
            </div>
          </Slider>
          <a href="https://wa.me/+17542622405" target="whatsapp" className="whatsapp-button">
          <svg xmlns="http://www.w3.org/2000/svg" width={60} height={60} viewBox="0 0 256 258">
            <defs>
              <linearGradient id="logosWhatsappIcon0" x1="50%" x2="50%" y1="100%" y2="0%">
                <stop offset="0%" stopColor="#1faf38"></stop>
                <stop offset="100%" stopColor="#60d669"></stop>
              </linearGradient>
              <linearGradient id="logosWhatsappIcon1" x1="50%" x2="50%" y1="100%" y2="0%">
                <stop offset="0%" stopColor="#f9f9f9"></stop>
                <stop offset="100%" stopColor="#fff"></stop>
              </linearGradient>
            </defs>
            <path fill="url(#logosWhatsappIcon0)" d="M5.463 127.456c-.006 21.677 5.658 42.843 16.428 61.499L4.433 252.697l65.232-17.104a123 123 0 0 0 58.8 14.97h.054c67.815 0 123.018-55.183 123.047-123.01c.013-32.867-12.775-63.773-36.009-87.025c-23.23-23.25-54.125-36.061-87.043-36.076c-67.823 0-123.022 55.18-123.05 123.004"></path>
            <path fill="url(#logosWhatsappIcon1)" d="M1.07 127.416c-.007 22.457 5.86 44.38 17.014 63.704L0 257.147l67.571-17.717c18.618 10.151 39.58 15.503 60.91 15.511h.055c70.248 0 127.434-57.168 127.464-127.423c.012-34.048-13.236-66.065-37.3-90.15C194.633 13.286 162.633.014 128.536 0C58.276 0 1.099 57.16 1.071 127.416m40.24 60.376l-2.523-4.005c-10.606-16.864-16.204-36.352-16.196-56.363C22.614 69.029 70.138 21.52 128.576 21.52c28.3.012 54.896 11.044 74.9 31.06c20.003 20.018 31.01 46.628 31.003 74.93c-.026 58.395-47.551 105.91-105.943 105.91h-.042c-19.013-.01-37.66-5.116-53.922-14.765l-3.87-2.295l-40.098 10.513z"></path>
            <path fill="#fff" d="M96.678 74.148c-2.386-5.303-4.897-5.41-7.166-5.503c-1.858-.08-3.982-.074-6.104-.074c-2.124 0-5.575.799-8.492 3.984c-2.92 3.188-11.148 10.892-11.148 26.561s11.413 30.813 13.004 32.94c1.593 2.123 22.033 35.307 54.405 48.073c26.904 10.609 32.379 8.499 38.218 7.967c5.84-.53 18.844-7.702 21.497-15.139c2.655-7.436 2.655-13.81 1.859-15.142c-.796-1.327-2.92-2.124-6.105-3.716s-18.844-9.298-21.763-10.361c-2.92-1.062-5.043-1.592-7.167 1.597c-2.124 3.184-8.223 10.356-10.082 12.48c-1.857 2.129-3.716 2.394-6.9.801c-3.187-1.598-13.444-4.957-25.613-15.806c-9.468-8.442-15.86-18.867-17.718-22.056c-1.858-3.184-.199-4.91 1.398-6.497c1.431-1.427 3.186-3.719 4.78-5.578c1.588-1.86 2.118-3.187 3.18-5.311c1.063-2.126.531-3.986-.264-5.579c-.798-1.593-6.987-17.343-9.819-23.64"></path>
          </svg>
        </a>
        <div className="content">
          <Typography variant="h3" className="title">PARTS & ENGINES</Typography>
          <div className="why-cummins">
            <Typography variant="h4" className="why-cummins-title">WHY CUMMINS ORIGINAL PARTS MATTER</Typography>
            <Typography variant="h6" className="why-cummins-text">IN THE WORLD OF HEAVY-DUTY EQUIPMENT, EVERY PART PLAYS A CRUCIAL ROLE IN PERFORMANCE AND LONGEVITY. THAT’S WHY WE BELIIEVE IN THE IMPORTANCE OF USING CUMMINS ORIGINAL PARTS.</Typography>
          </div>
          <div>
            <Grid2 className="information" container>
              <Grid2 className='why-choose-section' item>
                <Typography variant="h4" className="why-choose">WHY CHOOSE OUR PARTS</Typography>
                <div className="info-item">
            <svg xmlns="http://www.w3.org/2000/svg" width={100} height={70} viewBox="0  0 24 24" style={{ display: 'block', margin: '0 auto', marginLeft:'10px', marginRight:'5px' }}>
              <path fill="black" stroke="white" strokeWidth={1} d="M8 11A5 5 0 1 0 8 1a5 5 0 0 0 0 10Zm6.643 4.696a6.75 6.75 0 0 0-1.62-2.673C11.772 11.76 10.013 11 8 11c-4 0-7 3-7 7v5h10m1-4.176L16.19 22L23 13"></path>
            </svg>
            <div>
              <p className="information-title" style={{marginLeft:'0px !important'}}>DEEP INDUSTRY EXPERIENCE</p>
              <Typography variant="body1" className="information-text">THESE PARTS ARE DESIGNED AND ENGINEERED SPECIFICALLY FOR CUMMINS ENGINES, ENSURING OPTIMAL FIT, FUNCTION, AND RELIABILITY.</Typography>
            </div>
          </div>
          <div className="info-item">
            <svg xmlns="http://www.w3.org/2000/svg" width={170} height={95} viewBox="0 0  24 24" style={{ display: 'block', margin: '0 auto' }}>
              <path fill="white" fillRule="evenodd" d="M15.418 5.643a1.25 1.25 0 0 0-1.34-.555l-1.798.413a1.25 1.25 0 0 1-.56 0l-1.798-.413a1.25 1.25 0 0 0-1.34.555l-.98 1.564c-.1.16-.235.295-.395.396l-1.564.98a1.25 1.25 0 0 0-.555 1.338l.413 1.8a1.25 1.25 0 0 1 0 .559l-.413 1.799a1.25 1.25 0 0 0 .555 1.339l1.564.98c.16.1.295.235.396.395l.98 1.564c.282.451.82.674 1.339.555l1.798-.413a1.25 1.25 0 0 1 .56 0l1.799.413a1.25 1.25 0 0 0 1.339-.555l.98-1.564c.1-.16.235-.295.395-.395l1.565-.98a1.25 1.25 0 0 0 .554-1.34L18.5 12.28a1.25 1.25 0 0 1 0-.56l.413-1.799a1.25 1.25 0 0 0-.554-1.339l-1.565-.98a1.25 1.25 0 0 1-.395-.395zm-.503 4.127a.5.5 0 0 0-.86-.509l-2.615 4.426l-1.579-1.512a.5.5 0 1 0-.691.722l2.034 1.949a.5.5 0 0 0 .776-.107z" clipRule="evenodd"></path>
            </svg>
            <div>
              <p className="information-title">CHOOSING CUMMINS ORIGINAL PARTS</p>
              <Typography variant="body1" className="information-text">INVESTING IN THE LONG-TERM PERFORMANCE AND RELIABILITY OF YOUR ENGINE. DON’T COMPROMISE-ENSURE YOUR ENGINE OPERATES AT ITS BEST WITH THE PARTS IT WAS DESIGNED FOR.</Typography>
            </div>
          </div>
          <div className="info-item">
            <svg xmlns="http://www.w3.org/2000/svg" width={120} height={100} viewBox="0 0 512 512"style={{ display: 'block', margin: '0 auto', marginLeft:'10px', marginRight:'5px' }}>
              <path fill="white" d="m241.406 21l-15.22 34.75a182 182 0 0 0-23.467 2.97l-23.282-30.064l-25.094 8.532l-.125 38.25c-10.63 5.464-20.817 12.07-30.44 19.78L88.313 79.25L70.156 98.563L88.312 133a180.6 180.6 0 0 0-15.218 26.094l-38.938 1.062l-7.906 25.28l31.438 23.158c-1.505 9.38-2.24 18.858-2.282 28.344L20.5 254.625l3.656 26.25l38.313 7.5a182 182 0 0 0 8.5 23.5L45.72 343.22l14.093 22.436l39.25-9.187a185 185 0 0 0 7.718 8.53a187 187 0 0 0 17.72 16.125l-7.625 39.313l22.938 13.25l29.968-26.094a179.4 179.4 0 0 0 26.407 8.312l9.782 38.406l26.405 2.157l15.875-36.22c10.97-.66 21.904-2.3 32.656-4.938l25.22 29.22l24.593-9.844l-.72-14.813l-57.406-43.53c-16.712 4.225-34.042 5.356-51.063 3.436c-31.754-3.58-62.27-17.92-86.218-42.686c-54.738-56.614-53.173-146.67 3.438-201.406c27.42-26.513 62.69-39.963 98-40.344c37.59-.406 75.214 13.996 103.438 43.187c45.935 47.512 52.196 118.985 19.562 173.095l31.97 24.25a181 181 0 0 0 10.75-19.375l38.655-1.063l7.906-25.28l-31.217-23a183 183 0 0 0 2.28-28.594l34.688-17.625l-3.655-26.25l-38.28-7.5a182 182 0 0 0-12.75-32.125l22.81-31.594l-15.25-21.657l-37.56 10.906c-.472-.5-.93-1.007-1.408-1.5a185 185 0 0 0-18.937-17.064l7.188-37.125L334 43.78l-28.5 24.814c-9.226-3.713-18.702-6.603-28.313-8.75l-9.343-36.688zM183.25 174.5c-10.344.118-20.597 2.658-30 7.28l45.22 34.314c13.676 10.376 17.555 30.095 7.06 43.937c-10.498 13.85-30.656 15.932-44.53 5.408l-45.188-34.282c-4.627 24.793 4.135 51.063 25.594 67.344c19.245 14.597 43.944 17.33 65.22 9.688l4.78-1.72l4.03 3.063l135.19 102.564l4.03 3.062l-.344 5.063c-1.637 22.55 7.59 45.61 26.844 60.217c21.46 16.28 49.145 17.63 71.78 6.5l-45.186-34.28c-13.874-10.526-17.282-30.506-6.78-44.344c10.5-13.84 30.537-15.405 44.217-5.032l45.188 34.283c4.616-24.784-4.11-51.067-25.563-67.344c-19.313-14.658-43.817-17.562-64.968-10.033l-4.75 1.688l-4.03-3.063l-135.19-102.562l-4.03-3.063l.344-5.03c1.55-22.387-7.85-45.194-27.157-59.845c-12.544-9.516-27.222-13.978-41.78-13.812zm43.563 90.25l163.875 124.344L379.406 404L215.5 279.625z"></path>
            </svg>
            <div>
              <p className="information-title">EXPERT SUPPORT</p>
              <Typography variant="body1" className="information-text">EXPERT DIESEL PROVIDES EXPERT SUPPORT AND RESOURCES ENSURING THAT YOU HAVE ACCESS TO THE INFORMATION YOU NEED FOR MAINTENANCE AND REPAIRS.</Typography>
            </div>
          </div>
                <Button className="online-parts" onClick={handleScroll}>ONLINE PARTS</Button>
              </Grid2>
              <hr className="info-div"/>
              <Grid2 className='original-section' item>
                <Typography variant="h4" className="original-parts">CUMMINS ORIGINAL PARTS </Typography>
                <p className="information-title-og">QUALITY ASSURANCE</p>
                <Typography variant="body1" className="information-text-og">CUMMINS ORIGINAL PARTS ARE DESIGNED AND MANUFACTURED TO MEET STRICT QUALITY STANDARDS. THEY ENSURE OPTIMAL PERFORMANCE AND LONGEVITY.</Typography>
                <p className="information-title-og">PERFECT FIT</p>
                <Typography variant="body1" className="information-text-og">THESE PARTS ARE ENGINEERED SPECIFICALLY FOR CUMMINS ENGINES, GUARANTEENING A PERFECT FIT AND SEAMLESS INTEGRATION, WHICH REDUCES THE RISK OF MECHANICAL ISSUES.</Typography>
                <p className="information-title-og">RELIABILITY</p>
                <Typography variant="body1" className="information-text-og">WITH CUMMINS ORIGINAL PARTS, YOU CAN TRUST  THAT YOU’RE GETTING COMPONENTS THAT ARE BUILT TO WITHSTAND THE DEMANDS OF YOUR ENGINE, PROVIDING PEACE OF MIND AND RELIABILITY.</Typography>
                <p className="information-title-og">WARRANTY PROTECTION</p>
                <Typography variant="body1" className="information-text-og">USING ORIGINAL PARTS HELP MAINTAIN YOUR ENGINE’S WARRANTY. THIS MEANS YOU CAN SAFEGUARD YOUR INVESTMENT AND AVOID UNEXPECTED REPAIR COSTS.</Typography>
              </Grid2>
            </Grid2>
          </div>
          <div className="video-container" id="video-section"> 
            <video className="custom-video" controls autoPlay loop muted> 
              <source src={require("../assets/VIDEOS/VIDEO_PARTES.mp4")} type="video/mp4" /> 
              Your browser does not support the video tag. 
            </video> 
          </div>
          <div className="form-container" id="form-section">
            <form ref={form} onSubmit={sendEmail}>
              <Grid2 container>
                <Grid2 item xs={12} md={5} className="Grid2-item">
                  <p className="contact-info-title">CONTACT INFORMATION</p>
                  <hr className="form-division"/>
                  <div className="form-group-parts">
                    <p className="tittles">NAME:*</p>
                    <input type="text" name="user_name" placeholder="Name" required />
                  </div>
                  <div className="form-group-parts">
                    <p className="tittles">PHONE:*</p>
                    <input type="text" name="phone" placeholder="Phone Number" required />
                  </div>
                  <div className="form-group-parts">
                    <p className="tittles">ALTERNATE PHONE:</p>
                    <input type="text" name="alternate_phone" placeholder="Alternate Phone Number" />
                  </div>
                  <div className="form-group-parts">
                    <p className="tittles">EMAIL:*</p>
                    <input type="text" name="email" placeholder="Email" required />
                  </div>
                  <button type="submit" className="send-button-parts">SEND</button>
                </Grid2>    
                <Grid2 item xs={12} md={5} className="Grid2-item">
                  <p className="contact-info-title">ENGINE INFORMATION</p>
                  <hr className="form-division"/>
                  <div className="form-group-parts">
                    <p className="tittles">ENGINE SERIAL NUMBER:*</p>
                    <div className="input-with-icon">
                      <input
                        minLength="8"
                        maxLength="17"
                        type="text"
                        name="engine_serial_number"
                        placeholder="ESN, GSN OR VIN"
                        required
                        style={{ textTransform: 'uppercase' }}
                        onInput={(e) => e.target.value = e.target.value.toUpperCase()}
                      />
                      <svg style={{ marginBottom: "-0.5rem", cursor: "pointer", marginLeft:'-2rem'}} onClick={() => setShowTooltip(true)} xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24"><path fill="currentColor" d="M11 17h2v-6h-2zm1-8q.425 0 .713-.288T13 8t-.288-.712T12 7t-.712.288T11 8t.288.713T12 9m0 13q-2.075 0-3.9-.788t-3.175-2.137T2.788 15.9T2 12t.788-3.9t2.137-3.175T8.1 2.788T12 2t3.9.788t3.175 2.137T21.213 8.1T22 12t-.788 3.9t-2.137 3.175t-3.175 2.138T12 22m0-2q3.35 0 5.675-2.325T20 12t-2.325-5.675T12 4T6.325 6.325T4 12t2.325 5.675T12 20m0-8"></path></svg>
                      {showTooltip && (
                        <div className="modal">
                        <div className="modal-content">
                          <button className="close-btn" onClick={() => setShowTooltip(false)}>&times;</button>
                          <p className="modal-title">How to find your VIN, ESN, GSN</p>
                          <hr className="serial-devider" />
                          <p className="modal-subtitle">Find ESN</p>
                          <p className="modal-text">Engine serial number (ESN) can be found on the engine data-plate, typically located on the engine rocker cover or the side of the gear housing.</p>
                          <img src={require("../assets/esn.avif")} alt="ESN Example" className="tooltip-image" />
                          <hr className="serial-devider" />
                          <p className="modal-subtitle">Find GSN</p>
                          <p className="modal-text">Generator serial number (GSN) can be found on a plate on the reverse of the generator, for many models this will be close to the gas output.</p>
                          <img src={require("../assets/gsn.avif")} alt="GSN Example" className="tooltip-image" />
                          <hr className="serial-devider" />
                          <p className="modal-subtitle">Find VIN</p>
                          <p className="modal-text">Vehicle serial number (VIN) can be found on the dashboard on the driver’s side, or under the hood of the car near the engine, or under the front grille of the car, or on the driver’s side door or rear wheel.</p>
                          <img src={require("../assets/vin.avif")} alt="VIN Example" className="tooltip-image" />
                        </div>
                      </div>
                      )}
                    </div>
                  </div>
                  <div className="form-group-parts">
                    <p className="tittles">PART NAME(S):*</p>
                    <input type="text" name="part_names" placeholder="PART NAME OR NAMES" required />
                  </div>
                  <div className="form-group-parts">
                    <p className="tittles">PART NUMBER(S):*</p>
                    <input type="text" name="part_numbers" placeholder="PART NUMBER OR NUMBERS" required />
                  </div>
                  <div className="form-group-parts">
                    <p className="tittles">COMMENTS:</p>
                    <input type="text" name="comments" placeholder="SOME OBSERVATIONS" />
                  </div>
                </Grid2>
              </Grid2>
            </form>
          </div>
          <div className="footer">
        <Grid2 container spacing={2} className="footer-container">
        <Grid2 item xs={12} md={6} className="footer-right">
              <div className="map-container">
                <LoadScript googleMapsApiKey="AIzaSyBN6CqhMJnBIJnFR2NwAFBC4ya2XdHVKoc">
                  <GoogleMap
                    mapContainerStyle={mapContainerStyle}
                    center={center}
                    zoom={14}
                  >
                    <Marker position={center} title="My location" />
                  </GoogleMap>
                  <div className="map-info">
                    <p className='map-text'>EXPERT DIESEL | 4700 OAKES RD | HOLLYWOOD, FL 33314</p>
                    <h6 className='call-us-text'>CALL US TODAY AT 954-583-2400 FOR MORE INFORMATION!!</h6>
                  </div>
                </LoadScript>
              </div>
            </Grid2>
            <Grid2 item xs={12} md={6} className="footer-left">
              <Typography variant="h4" className="some-our-main">SOME OUR MAIN CUSTOMERS</Typography>
              <Typography variant="h6" className="some-our-text">We provide Cummins, Autocar and diesel engine service and repairs for all of South Florida, including the following counties and cities:</Typography>
              <Typography variant="h6" className="some-our-list">
                <Grid2 container className="list">
                  <Grid2 item xs={6}>
                    <ul>
                      <li>Broward County</li>
                      <li>Miami-Dade County</li>
                      <li>Fort Lauderdale</li>
                      <li>Plantation</li>
                      <li>Sunrise</li>
                      <li>Pembroke Pines</li>
                      <li>Cooper City</li>
                      <li>Davie</li>
                      <li>Coral Springs</li>
                      <li>Tamarac</li>
                      <li>Boca Raton</li>
                    </ul>
                  </Grid2>
                  <Grid2 item xs={6}>
                    <ul>
                      <li>Delray Beach</li>
                      <li>Deerfield Beach</li>
                      <li>Pompano Beach</li>
                      <li>Hollywood</li>
                      <li>Aventura</li>
                      <li>North Miami Beach</li>
                      <li>Kendall</li>
                      <li>Miami Beach</li>
                      <li>Miami</li>
                      <li>Key Biscayne</li>
                      <li>Many more!!!</li>
                    </ul>
                  </Grid2>
                </Grid2>
              </Typography>
            </Grid2>
          </Grid2>
        </div>
      <div className="connect-with-us">
      <Typography variant="h4">CONNECT WITH US</Typography>
            {showPhoneModal && (
            <div className="aviso">
              <div className="aviso-content">
                <button className="close-btn-aviso" onClick={() => setShowPhoneModal(false)}>
                  &times;
                </button>
                <p className="aviso-title">CONTACT</p>
                <p className="aviso-text">Our contact number is: +1 (954)-583-2400</p>
              </div>
            </div>
          )}
          <Grid2 container spacing={2}>
            <Grid2 item xs={12} md={4} className="logo-section" onClick={() => setShowPhoneModal(true)} style={{ cursor: 'pointer', textAlign: 'center' }}>
            <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24"><path fill="currentColor" d="M12 2C6.486 2 2 6.486 2 12v4.143C2 17.167 2.897 18 4 18h1a1 1 0 0 0 1-1v-5.143a1 1 0 0 0-1-1h-.908C4.648 6.987 7.978 4 12 4s7.352 2.987 7.908 6.857H19a1 1 0 0 0-1 1V18c0 1.103-.897 2-2 2h-2v-1h-4v3h6c2.206 0 4-1.794 4-4c1.103 0 2-.833 2-1.857V12c0-5.514-4.486-10-10-10"></path></svg>
              <Typography variant="body1" style={{fontWeight:'bold', paddingTop:'10px'}}>GET SUPPORT</Typography>
            </Grid2>
            <hr className="logo-divider" />
            <Grid2 item xs={12} md={4} className="logo-section">
            <Link to="#form-section" className="request-quote-button" onClick={handleScroll}>
              <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24">
                <path fill="currentColor" d="M6 22q-.825 0-1.412-.587T4 20V4q0-.825.588-1.412T6 2h8l6 6v12q0 .825-.587 1.413T18 22zm5-3h2v-1h1q.425 0 .713-.288T15 17v-3q0-.425-.288-.712T14 13h-3v-1h4v-2h-2V9h-2v1h-1q-.425 0-.712.288T9 11v3q0 .425.288.713T10 15h3v1H9v2h2zm2.175-11h4l-4-4z"></path>
              </svg>
              <Typography variant="body1" style={{fontWeight:'bold', paddingTop:'10px'}}>REQUEST A QUOTE</Typography>
            </Link>
            </Grid2>
            <hr className="logo-divider" />
            <Grid2 item xs={12} md={4} className="logo-section">
              <Link to="/Service#form-section-serv" style={{ textDecoration: 'none', color: 'inherit', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <svg xmlns="http://www.w3.org/2000/svg" width={512} height={512} viewBox="0 0 512 512"><path fill="currentColor" d="M80.08 82.66L60.24 102.5L192.9 242.7v58.6h78v-50.9zm-25.4 40.14v80.3l4.01 2.7c10.56 7 14.74 14.1 15.93 19.8c1.18 5.8-.43 10.8-3.85 14.9c-6.86 8.3-19.91 12.3-32.73-.6l-12.72 12.8c19.18 19.1 46.13 15.1 59.27-.6c6.58-7.9 9.97-18.9 7.65-30.1c-2.05-10-8.72-19.7-19.56-28v-52.2zm258.02 52.5v144h-185c22.6 5.8 40.6 23.5 46.7 46H337c7.5-27.6 32.8-48 62.7-48s55.2 20.4 62.7 48h24.3v-84.6l-60.2-105.4zm36 14h62.1l54.7 92H348.7v-83zm-321.49 130l11.5 46h10.25c6.12-22.5 24.09-40.2 46.74-46zm84.49 16c-26.08 0-47.02 20.9-47.02 47s20.94 47 47.02 47c26.1 0 47-20.9 47-47s-20.9-47-47-47m288 0c-26.1 0-47 20.9-47 47s20.9 47 47 47s47-20.9 47-47s-20.9-47-47-47"></path></svg>
                <Typography variant="body1" style={{ fontWeight: 'bold', paddingTop: '10px' }}>
                  REQUEST A SERVICE
                </Typography>
              </Link>
            </Grid2>        
          </Grid2>
          <Typography variant="body1" className="connect-text"> © 2024 Expert diesel, Box 3005, Columbus, IN 47202-3005 U.S.A.</Typography>
          <Grid2 container spacing={2} className="social-buttons">
            <Grid2 item xs={12} md={2}>
              <Button className="social-button">ACCESIBILITY</Button>
            </Grid2>
            <Grid2 item xs={12} md={2}>
              <Button className="social-button">PRIVACY POLICY</Button>
            </Grid2>
            <Grid2 item xs={12} md={2}>
              <Button className="social-button">TERMS OF USE</Button>
            </Grid2>
            <Grid2 item xs={12} md={2}>
              <Button className="social-button">COOKIE NOTICE</Button>
            </Grid2>
            <Grid2 item xs={12} md={2}>
              <Button className="social-button">SITE MAP</Button>
            </Grid2>
            <Grid2 item xs={12} md={2} className="logo-buttons">
              <Button className="logo-button">
              <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24"><path fill="white" d="M7.8 2h8.4C19.4 2 22 4.6 22 7.8v8.4a5.8 5.8 0 0 1-5.8 5.8H7.8C4.6 22 2 19.4 2 16.2V7.8A5.8 5.8 0 0 1 7.8 2m-.2 2A3.6 3.6 0 0 0 4 7.6v8.8C4 18.39 5.61 20 7.6 20h8.8a3.6 3.6 0 0 0 3.6-3.6V7.6C20 5.61 18.39 4 16.4 4zm9.65 1.5a1.25 1.25 0 0 1 1.25 1.25A1.25 1.25 0 0 1 17.25 8A1.25 1.25 0 0 1 16 6.75a1.25 1.25 0 0 1 1.25-1.25M12 7a5 5 0 0 1 5 5a5 5 0 0 1-5 5a5 5 0 0 1-5-5a5 5 0 0 1 5-5m0 2a3 3 0 0 0-3 3a3 3 0 0 0 3 3a3 3 0 0 0 3-3a3 3 0 0 0-3-3"></path></svg>
              </Button>
              <Button className="logo-button">
              <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24"><g fill="none"><path d="m12.593 23.258l-.011.002l-.071.035l-.02.004l-.014-.004l-.071-.035q-.016-.005-.024.005l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427q-.004-.016-.017-.018m.265-.113l-.013.002l-.185.093l-.01.01l-.003.011l.018.43l.005.012l.008.007l.201.093q.019.005.029-.008l.004-.014l-.034-.614q-.005-.018-.02-.022m-.715.002a.02.02 0 0 0-.027.006l-.006.014l-.034.614q.001.018.017.024l.015-.002l.201-.093l.01-.008l.004-.011l.017-.43l-.003-.012l-.01-.01z"></path><path fill="white" d="M12 4c.855 0 1.732.022 2.582.058l1.004.048l.961.057l.9.061l.822.064a3.8 3.8 0 0 1 3.494 3.423l.04.425l.075.91c.07.943.122 1.971.122 2.954s-.052 2.011-.122 2.954l-.075.91l-.04.425a3.8 3.8 0 0 1-3.495 3.423l-.82.063l-.9.062l-.962.057l-1.004.048A62 62 0 0 1 12 20a62 62 0 0 1-2.582-.058l-1.004-.048l-.961-.057l-.9-.062l-.822-.063a3.8 3.8 0 0 1-3.494-3.423l-.04-.425l-.075-.91A41 41 0 0 1 2 12c0-.983.052-2.011.122-2.954l.075-.91l.04-.425A3.8 3.8 0 0 1 5.73 4.288l.821-.064l.9-.061l.962-.057l1.004-.048A62 62 0 0 1 12 4m0 2c-.825 0-1.674.022-2.5.056l-.978.047l-.939.055l-.882.06l-.808.063a1.8 1.8 0 0 0-1.666 1.623C4.11 9.113 4 10.618 4 12s.11 2.887.227 4.096c.085.872.777 1.55 1.666 1.623l.808.062l.882.06l.939.056l.978.047c.826.034 1.675.056 2.5.056s1.674-.022 2.5-.056l.978-.047l.939-.055l.882-.06l.808-.063a1.8 1.8 0 0 0 1.666-1.623C19.89 14.887 20 13.382 20 12s-.11-2.887-.227-4.096a1.8 1.8 0 0 0-1.666-1.623l-.808-.062l-.882-.06l-.939-.056l-.978-.047A61 61 0 0 0 12 6m-2 3.575a.6.6 0 0 1 .819-.559l.081.04l4.2 2.424a.6.6 0 0 1 .085.98l-.085.06l-4.2 2.425a.6.6 0 0 1-.894-.43l-.006-.09z"></path></g></svg>
              </Button>
              <Button className="logo-button">
              <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24"><path fill="white" d="M19 3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2zm-.5 15.5v-5.3a3.26 3.26 0 0 0-3.26-3.26c-.85 0-1.84.52-2.32 1.3v-1.11h-2.79v8.37h2.79v-4.93c0-.77.62-1.4 1.39-1.4a1.4 1.4 0 0 1 1.4 1.4v4.93zM6.88 8.56a1.68 1.68 0 0 0 1.68-1.68c0-.93-.75-1.69-1.68-1.69a1.69 1.69 0 0 0-1.69 1.69c0 .93.76 1.68 1.69 1.68m1.39 9.94v-8.37H5.5v8.37z"></path></svg>
              </Button>
              <Button className="logo-button">
              <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} viewBox="0 0 20 20"><path fill="white" fillRule="evenodd" d="M18.896 0H1.104C.494 0 0 .494 0 1.104v17.792C0 19.506.494 20 1.104 20h9.578v-7.745H8.076V9.237h2.606V7.01c0-2.584 1.578-3.99 3.883-3.99c1.104 0 2.052.082 2.329.119v2.7h-1.598c-1.254 0-1.496.596-1.496 1.47v1.927h2.989l-.39 3.018h-2.6V20h5.097c.61 0 1.104-.494 1.104-1.104V1.104C20 .494 19.506 0 18.896 0"></path></svg>
              </Button>
            </Grid2>
          </Grid2>
        </div>
      </div>
    </div>
  </div>
    );
  };
  
  export default PartsEngineSales;